module.exports = __webpack_public_path__ + "static/media/Todolist.6638594f.png";